import { useReducer, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGetProjectsQuery } from "../../features/projects/projectsApi";
import { useAddTaskMutation, useEditTaskMutation } from "../../features/tasks/tasksApi";
import { useGetTeamsQuery } from "../../features/teams/teamsApi";

export default function TaskForm({ initialTask = {} }) {

  const [addTask, { isLoading: addTaskLoading, isSuccess: addTaskSuccess }] = useAddTaskMutation();
  const [editTask, { isLoading: editTaskLoading, isSuccess: editTaskSuccess }] = useEditTaskMutation();
  const { data: teams, isLoading: teamsLoading } = useGetTeamsQuery()
  const { data: projects, isLoading: projectsLoading } = useGetProjectsQuery()

  const navigate = useNavigate()
  const initialData = {
    taskName: initialTask?.taskName || '',
    teamMemberId: initialTask?.teamMember?.id || '',
    projectId: initialTask?.project?.id || '',
    deadline: initialTask?.deadline || '',
    status: initialTask?.status || 'pending',
  };

  const [data, setData] = useReducer((prev, next) => {
    return { ...prev, ...next };
  }, initialData)


  const handleSubmit = (e) => {
    e.preventDefault();

    const body = {
      taskName: data.taskName,
      deadline: data?.deadline || '',
      status: data?.status || 'pending',
      project: projects.find(project => project.id == data?.projectId),
      teamMember: teams.find(team => team.id == data?.teamMemberId),
    }

    if (initialTask?.id) {
      editTask({ id: initialTask?.id, data: body })
    } else {
      addTask(body)
    }
  }

  useEffect(() => {
    if (addTaskSuccess || editTaskSuccess) {
      setData({ ...initialData })
      navigate("/")
    }

  }, [addTaskSuccess, editTaskSuccess, navigate]);

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="fieldContainer">
        <label htmlFor="lws-taskName">Task Name</label>
        <input
          value={data.taskName}
          onChange={e => setData({ taskName: e.target.value })}
          type="text"
          name="taskName"
          id="lws-taskName"
          required
          placeholder="Implement RTK Query"
        />
      </div>

      <div className="fieldContainer">
        <label>Assign To</label>
        <select name="teamMember" value={data.teamMemberId} onChange={e => setData({ teamMemberId: e.target.value })} id="lws-teamMember" required>
          <option value="" hidden >Select Job</option>
          {teams?.length ?
            teams.map(team => (
              <option key={team.id} value={team.id} >{team.name}</option>
            ))
            : null
          }
        </select>
      </div>
      <div className="fieldContainer">
        <label htmlFor="lws-projectName">Project Name</label>
        <select value={data.projectId} onChange={e => setData({ projectId: e.target.value })} id="lws-projectName" name="projectName" required>
          <option value="" hidden >Select Project</option>
          {projects?.length ?
            projects.map(project => (
              <option key={project.id} value={project.id} >{project.projectName}</option>
            ))
            : null
          }
        </select>
      </div>

      <div className="fieldContainer">
        <label htmlFor="lws-deadline">Deadline</label>
        <input value={data.deadline} onChange={e => setData({ deadline: e.target.value })} type="date" name="deadline" id="lws-deadline" required />
      </div>

      <div className="text-right">
        <button type="submit" className="lws-submit">Save</button>
      </div>
    </form>
  )
}